import { ArrowDropUp, Height } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { COLOR_PALETTE_LIST, darkblueColor, growthGreenColor, lightBrownColor } from "components/Reports/data";
import DonutChart from "components/Reports/ReusableComponents/DonutChart/DonutChart";
import StackedBarGraph from "components/Reports/ReusableComponents/StackedBarGraph/StackedBarGraph";
import { roundDecimalValueUptoTwo } from "utils/roundDecimalValue";
import { l1VerticalCardTypes, l1verticalCardWidth } from "../data";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const dataFormat = {
	name: "name",
	ty_ach_value: "ty_ach_value",
	ly_ach_value: "ly_ach_value",
	ty_aop_value: "ty_aop_value",
	ly_aop_value: "ly_aop_value",
	ty_total_sale_value: "ty_total_sale_value",
};

const L1VerticalCard = ({
	sx,
	cardDetails = {},
	fullData = dataFormat,
	valRoundOffFun = (val) => val,
	percentRoundOffFun = (val) => val,
	barGraphValueConverter,
	barGraphlabelData = {},
	hideAop = false,
}) => {
	const data = fullData[cardDetails.key];
	let ty_ach_value = Number(data?.[dataFormat.ty_ach_value]) || 0;
	let ly_ach_value = Number(data?.[dataFormat.ly_ach_value]) || 0;
	let ty_aop_value = Number(data?.[dataFormat.ty_aop_value]) || 0;
	let ly_aop_value = Number(data?.[dataFormat.ly_aop_value]) || 0;
	let ty_total_sale_value = Number(data?.[dataFormat.ty_total_sale_value]) || 0;

	const tyLyGrowthPercent = percentRoundOffFun(((ty_ach_value - ly_ach_value) / ly_ach_value) * 100);
	const tyAopAchPercent = percentRoundOffFun((ty_ach_value / ty_aop_value) * 100) || 0;
	const lyAopAchPercent = ly_aop_value ? (percentRoundOffFun((ly_ach_value / ly_aop_value) * 100) || 0) : 0;

	const tyLyAopAchPercent = lyAopAchPercent? (percentRoundOffFun(((tyAopAchPercent - lyAopAchPercent) / lyAopAchPercent) * 100) || 0) : 0;
	const precentOfTotalSale = percentRoundOffFun((ty_ach_value / ty_total_sale_value) * 100) || 0;
	console.log(cardDetails, fullData, ty_ach_value, "sdfgdshfsdhgfvhsdfgshd");

	const barGraphRows = data?.["bar_graph"]
		? Object.keys(data["bar_graph"])?.map((key) => {
				const keyData = data["bar_graph"][key];
				let obj = {
					label: key.toUpperCase(),
					segments: Object.keys(keyData)?.map((segmentKey) => ({
						value: keyData[segmentKey]?.ty_ach_value,
						text: segmentKey,
						brand: segmentKey,
						...keyData[segmentKey]	
					})),
				};
				return obj;
		  })
		: [];
	const sunBurstRows = {
		name: "sales",
		children: data?.["sun_burst_graph"]
			? Object.keys(data["sun_burst_graph"])?.map((key) => {
					const keyData = data["sun_burst_graph"][key];
					let obj = {
						name: key.toUpperCase(),
						value: keyData.ty_ach_val,
						...keyData,
						children: keyData?.channels
							? Object.keys(keyData?.channels)?.map((channel) => ({
									value: keyData.channels[channel]?.ty_ach_val,
									name: channel,
									...keyData.channels[channel]
							  }))
							: [],
					};
					return obj;
			  })
			: [],
	};

	let arrow = <ArrowDropUp fontSize="large" sx={{ color: "var(--color-growth)" }} />
	if (cardDetails?.key === l1VerticalCardTypes.discount.key && tyLyGrowthPercent > 0){
		arrow = <ArrowDropDownIcon fontSize="large" sx={{ color: "var(--color-degrowth)" }} />
	}
	else if(cardDetails?.key !== l1VerticalCardTypes.discount.key && tyLyGrowthPercent < 0){
		arrow = <ArrowDropDownIcon fontSize="large" sx={{ color: "var(--color-degrowth)" }} />
	}
	console.log(data, barGraphRows, sunBurstRows, "barGraphRows");
	return (
		<Stack sx={{ ...sx, minWidth: l1verticalCardWidth, height: "48rem", background: "white" }}>
			<Stack p={1} pl={3}>
				<Typography sx={{fontSize:"var(--font-size-body)"}} fontWeight={400} width="100%" color={darkblueColor} textTransform="uppercase">
					{cardDetails?.name}
				</Typography>
				<Box display="flex" width="100%" columnGap="0.2rem" alignItems="center">
					<Typography sx={{fontSize: "var(--font-size-body)"}} fontWeight={400} color={lightBrownColor}>
						{valRoundOffFun(ty_ach_value)}
					</Typography>
					{arrow}
				</Box>
				<Box display="flex" width="100%" columnGap="0.2rem" alignItems="center">
					<Typography sx={{fontSize: "var(--font-size-body)"}} fontWeight={400} color={darkblueColor}>
						VS {valRoundOffFun(ly_ach_value)} <span style={{ fontSize: 16 }}>({tyLyGrowthPercent}%)</span>
					</Typography>
				</Box>
				<Box
					display="flex"
					width="100%"
					columnGap="0.2rem"
					alignItems="center"
					pt={2}
					visibility={hideAop ? "hidden" : "visible"}>
					<Typography sx={{fontSize: "var(--font-size-body3)"}} fontWeight={400} color={"black"}>
						{tyAopAchPercent}%
					</Typography>
					<ArrowDropUp fontSize="large" sx={{ color: "var(--color-growth)" }} />
				</Box>
				<Box display="flex" width="100%" columnGap="0.2rem" alignItems="center" visibility={hideAop ? "hidden" : "visible"}>
					<Typography sx={{fontSize: "var(--font-size-body3)"}} fontWeight={400} color={"black"}>
						VS {lyAopAchPercent}% <span style={{ fontSize: 14 }}>({tyLyAopAchPercent}%)</span>
					</Typography>
					<ArrowDropUp fontSize="large" sx={{ color: "var(--color-growth)" }} />
				</Box>
				<Box display="flex" width="100%" columnGap="0.2rem" alignItems="center" pt={1}>
					<Typography sx={{fontSize: "var(--font-size-body3)"}} fontWeight={400} color={darkblueColor}>
						{valRoundOffFun(ty_total_sale_value)} | {precentOfTotalSale}%
					</Typography>
				</Box>
			</Stack>
			<StackedBarGraph
				sx={{ width: "90%", height: "25%", pt: 2, pb: 3 }}
				colors={COLOR_PALETTE_LIST}
				dataSet={barGraphRows}
				formatBarTotalValue={barGraphValueConverter}
				yLabel={barGraphlabelData?.y_axis ?? ""}
				valRoundOffFun ={valRoundOffFun}
				isDiscountType = {cardDetails?.key === l1VerticalCardTypes.discount.key}
			/>
			<DonutChart
				sx={{ width: "60%", height: "40%", marginLeft: "auto", marginRight: "auto", pt: 2 }}
				data={sunBurstRows}
				colors={COLOR_PALETTE_LIST}
				valRoundOffFun ={valRoundOffFun}
				isDiscountType = {cardDetails?.key === l1VerticalCardTypes.discount.key}
			/>
		</Stack>
	);
};

export default L1VerticalCard;
